import { type UseQueryResult, useQuery } from 'react-query';
import { VendorTermsAndConditionsService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetVendorTermAndConditionPageList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const VendorTermAndConditionPageList = useQuery(
    ['getVendorTermAndConditionPageList'],
    async () => {
      return await handleRequest(
        VendorTermsAndConditionsService.getApiCustomerApiVendorTermsAndConditionsPages()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return VendorTermAndConditionPageList;
};

export default useGetVendorTermAndConditionPageList;
